module.exports = __webpack_public_path__ + "static/logo-c5af5eb49cc27ae96bbe17891ccfd193.svg";